export default {
    getTypeProcesses: { method: 'get', url: 'signatures/type-processes' },
    postTypeProcesses: { method: 'post', url: 'signatures/type-processes' },
    putTypeProcesses: { method: 'put', url: 'signatures/type-processes/{id}' },
    deleteTypeProcesses: { method: 'delete', url: 'signatures/type-processes/{id}' },
}
